import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';
import {getTimeStampDisplayFormat, getTimeStampValueFormat} from './time-stamp-formatter';
import {MdCheckboxChange} from '@angular/material';

@Component({
  selector: 'app-timestamp-field',
  templateUrl: './timestamp-field.component.html',
  styleUrls: ['./timestamp-field.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TimestampFieldComponent extends FieldComponentAbstract implements OnInit {

  mask = {
    mask: (value: string) => {
      const expression = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
      // if they type in a 2 then restrict the hours to less than 4 so you can't enter > 23
      if (value.length > 0 && Number(value.substr(0, 1)) === 2)
        expression[1] = /[0-3]/;
      return expression
    },
    placeholderChar: ' '
  };
  plusOne = false;
  minusOne = false;


  ngOnInit(): void {
    const timeStamp = getTimeStampDisplayFormat(this.fieldValue.timestamp_value);
    this.completed = this.fieldValue.timestamp_value != null;
    this.getControl().setValue(timeStamp.time);
    this.plusOne = timeStamp.plusOne;
    this.minusOne = timeStamp.minusOne;
  }

  onKeyUp() {
    this.completed = false;
    this.handleChange();
  }

  handleChange() {
    if (!this.isValid()) return;
    this.completed = true;
    this.fieldValue.timestamp_value = getTimeStampValueFormat(this.getControlValue<string>(), this.plusOne, this.minusOne);
    this.onChange(this.fieldValue);
  }

  onPlusOneChange(change: MdCheckboxChange) {
    this.plusOne = change.checked;
    if (this.plusOne && this.minusOne) this.minusOne = false;
    this.handleChange();
  }

  onMinusOneChange(change: MdCheckboxChange) {
    this.minusOne = change.checked;
    if (this.plusOne && this.minusOne) this.plusOne = false;
    this.handleChange();
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/timestamp-field/timestamp-field.component.ts